import { Icon } from "@root/shared/components/Icon";
import { type FC, Fragment } from "react";
import * as styles from "./styles.css";

type Props = {
  rank: "gold" | "silver" | "bronze";
  title: string;
  isSp?: boolean;
};

export const PhotoContestLabel: FC<Props> = ({ rank, title, isSp = false }) => {
  const parts = title.split(/(vol\.\d+)/);

  return (
    <span className={styles.label({ rank })} data-multiline={isSp ? "true" : "false"}>
      <span className={styles.imageOuter}>
        <Icon name="premium-scout" fontSize="13" />
      </span>
      {parts.map((part) => (
        <Fragment key={part}>
          {part}
          {isSp && /^vol\.\d+$/.exec(part) && <br />}
        </Fragment>
      ))}
    </span>
  );
};
